import {
  Box,
  Divider,
  FormControlLabel,
  RadioGroup,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React from "react";
import { useProviderOptionQuery } from "../services/ProviderService";
import {
  BulkRateRouteRequest,
  BulkRateRouteRequestType,
} from "../services/RoutingPlanDetailsService";
import CustomRadio from "./CustomRadio";
import RatePart from "./RatePart";
import RoutePart from "./RoutePart";

interface BulkRateRouteContentProps {
  setRequest: React.Dispatch<
    React.SetStateAction<Partial<BulkRateRouteRequest>>
  >;
  request: Partial<BulkRateRouteRequest>;
}

const BulkRateRouteContent: React.FC<BulkRateRouteContentProps> = ({
  request,
  setRequest,
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const dividerOrientation = isSmallScreen ? "horizontal" : "vertical";

  const handleTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRequest((prev) => ({
      ...prev,
      type: event.target.value as BulkRateRouteRequestType,
    }));
  };

  const { data: providerOptions } = useProviderOptionQuery();

  return (
    <Box
      p={2}
      display="flex"
      flexDirection="column"
      alignItems="center"
      sx={{
        width: "100%",
        maxWidth: { xs: 600, md: 1200 },
        margin: "0 auto",
      }}
    >
      <RadioGroup
        row
        value={request.type}
        onChange={handleTypeChange}
        sx={{
          width: { xs: "100%", md: "50%" },
          justifyContent: "space-around",
          mb: 5,
        }}
      >
        <FormControlLabel
          value={BulkRateRouteRequestType.RATE}
          control={<CustomRadio name="bulkRate" />}
          label="Rate"
        />
        <FormControlLabel
          value={BulkRateRouteRequestType.ROUTE}
          control={<CustomRadio name="bulkRate" />}
          label="Route"
        />
        <FormControlLabel
          value={BulkRateRouteRequestType.RATE_ROUTE}
          control={<CustomRadio name="bulkRate" />}
          label="Rate/Route"
        />
      </RadioGroup>

      {request.type === BulkRateRouteRequestType.RATE_ROUTE ? (
        <Box
          display="flex"
          flexDirection={{ xs: "column", md: "row" }}
          justifyContent="space-between"
          alignItems="flex-start"
          width="100%"
          mt={3}
        >
          <RatePart request={request} setRequest={setRequest} />
          <Divider
            orientation={dividerOrientation}
            flexItem
            sx={{
              mx: { xs: 0, md: 3 },
              my: { xs: 3, md: 0 },
            }}
          />
          <Box
            sx={{
              width: { xs: '100%' },
            }}
          >
            <RoutePart
              request={request}
              setRequest={setRequest}
              providerOptions={providerOptions?.map(option => ({
                label: option.label,
                value: String(option.value),
              }))}
            />
          </Box>
        </Box>
      ) : request.type === BulkRateRouteRequestType.RATE ? (
        <RatePart request={request} setRequest={setRequest} fullWidth />
      ) : request.type === BulkRateRouteRequestType.ROUTE ? (
        <RoutePart
          request={request}
          setRequest={setRequest}
          providerOptions={providerOptions?.map(option => ({
            label: option.label,
            value: String(option.value),
          }))}
          fullWidth
        />
      ) : null}
    </Box>
  );
};

export default BulkRateRouteContent;
